import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FileModel } from 'src/api/models';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss']
})
export class FileListComponent {
  @Input() files: Array<FileModel>;
  @Output() downloadEvent = new EventEmitter<FileModel>();

  public readonly faFileDownload = faFileDownload;

  constructor() { }

  download(file: FileModel): void {
    this.downloadEvent.emit(file)
  }
}
